import React from "react";
import { Sparkles } from "lucide-react";
import "./AgentsHero.css";

interface AgentsHeroProps {
  badge?: string;
  title?: string;
  subtitle?: string;
  description?: string;
  primaryButton?: string;
  secondaryButton?: string;
  image?: string; // ← single image now
}

export default function AgentsHero({
  badge = "AI Squared Hotel Agent",
  title = "Where Hospitality Meets Intelligence.",
  subtitle = "From booking to checkout and beyond, AI Squared perfects every step — your 24/7 concierge that listens, learns, and cares through WhatsApp.",
  primaryButton = "Explore Agents",
  secondaryButton = "Book a Demo",
  image,
}: AgentsHeroProps) {
  return (
    <section className="agents-hero">
      <div className="agents-hero-content">
        <div className="hero-text">
          <div className="hero-badge">
            <Sparkles size={16} className="badge-icon" /> {badge}
          </div>

          <h1 className="hero-title">{title}</h1>
          <p className="hero-subtitle">{subtitle}</p>

          <div className="hero-buttons">
            <button className="btn-primary">{primaryButton}</button>
            <button className="btn-secondary">{secondaryButton}</button>
          </div>
        </div>

        {image && (
            <img src={image} alt="Agent hero" className="hero-image" />
        )}
      </div>
    </section>
  );
}
